"use client";

import { Heading, Paragraph } from "@/components/ui/typography";
import { useEffect, useState, useMemo } from "react";
import Navigation from "./_components/Navigation-new";
import Header from "./_components/Header";
import { createDocument } from "@/lib/text-utils";
import { content } from "./data/privacypolicy.data";

const ContentRenderer = ({ content, index }) => {
  return (
    <div className="mb-6" id={content.id}>
      <Heading variant="h2" className="capitalize">
        {index + 1}. {content.title}
      </Heading>
      <div
        className="prose max-w-none text-midnightIndigo-400"
        dangerouslySetInnerHTML={{ __html: content.content }}
      />

      {content.subContent.map(item => {
        return (
          <div key={item.id} className="my-3" id={item.id}>
            <Heading variant="h4">{item.title}</Heading>
            <Paragraph>{item.content}</Paragraph>
            {item.children ? (
              <div
                className="prose max-w-none text-midnightIndigo-400"
                dangerouslySetInnerHTML={{ __html: item.children }}
              />
            ) : null}
          </div>
        );
      })}
    </div>
  );
};

const generatePrivacyPolicyData = () => {
  return createDocument("privacy-policy", "", content);
};

export default function Page() {
  const [menuData, setMenuData] = useState([]);

  // Memoize the privacy policy data
  const pageData = useMemo(() => generatePrivacyPolicyData(), []);

  useEffect(() => {
    if (pageData) {
      const menu = pageData.content.map((item, index) => ({
        id: item.id,
        number: `${index + 1}`,
        title: item.title,
        subMenu: item.subContent
          .filter(subItem => subItem.title)
          .map(subItem => ({
            id: subItem.id,
            number: subItem.title.split(" ")[0],
            title: subItem.title.split(" ").slice(1).join(" "),
          })),
      }));
      setMenuData(menu);
    }
  }, [pageData]);

  // Add scroll margin effect
  useEffect(() => {
    // Add scroll-margin-top to all sections
    const sections = document.querySelectorAll("[id]");
    sections.forEach(section => {
      section.style.scrollMarginTop = "100px";
    });
  }, []);

  return (
    <>
      <Header data={{ ...pageData, updatedOn: new Date("2024-12-12").toISOString() }} />
      <main className="relative mx-auto max-w-[1440px]">
        <section className="landing-container mt-[32px] flex max-w-[1440px] justify-between gap-2 md:mt-[64px] lg:gap-4">
          <div className="hidden w-[410px] md:block">
            <Navigation menu={menuData || []} />
          </div>
          <div className="mb-[32px] w-full md:mb-[124px]">
            <Paragraph className="mb-2">
              Welcome to Wireless World Shop. This Privacy Policy outlines how we collect, use, and
              protect your personal information. Please read this policy carefully to understand our
              practices regarding your personal data.
            </Paragraph>
            {pageData &&
              pageData.content.map((item, index) => (
                <ContentRenderer key={item.id} content={item} index={index} />
              ))}
          </div>
        </section>
      </main>
    </>
  );
}
